import { Spinner } from "react-bootstrap";
export const LoadingPage = () => {
  return (
    <div style={{ marginTop: "250px", textAlign: "center" }}>
      <Spinner animation="border" role="status" />
    </div>
  );
};
